<template>
  <header_en_m/>
  <News_index_en_m></News_index_en_m>
  <News_page_en_m></News_page_en_m>
  <br>
  <Footer_en_m/>
</template>

<script>
import Header_en_m from "@/components/EN_mobile/Header_en_m";
import News_index_en_m from "@/components/EN_mobile/news/News_index_en_m";
import News_page_en_m from "@/components/EN_mobile/news/News_page_en_m";
import Footer_en_m from "@/components/EN_mobile/Footer_en_m";
export default {
  name: 'News_en_m',
  components: {Footer_en_m, News_page_en_m, News_index_en_m, Header_en_m, },
}

</script>